import React from 'react';
import './LibraryInfrastructure.css';
import Footer from '../components/Footer';
import Navbar from '../components/navbar';
import PageHeader from '../about/PageHeader';
import CTAButton from '../components/sticky-button';
import {
  FaAward,
  FaBell,
  FaBookOpen,
  FaClock,
  FaDesktop,
  FaExchangeAlt,
  FaNewspaper,
  FaSearch,
  FaStar,
  FaUsers,
} from 'react-icons/fa';

const libraryServices = [
  { label: 'News Paper Clipping Service', icon: FaNewspaper },
  { label: 'Current Awareness Service', icon: FaBell },
  { label: 'Reference Service', icon: FaSearch },
  { label: 'Referral Service', icon: FaExchangeAlt },
  { label: 'Indexing Service through OPAC', icon: FaDesktop },
  { label: 'New Arrival Display', icon: FaStar },
  { label: 'Access to back issues of Journals', icon: FaClock },
  { label: 'Book Bank Service', icon: FaBookOpen },
  { label: 'Best Reader Award', icon: FaAward },
  { label: 'Book Reader Club', icon: FaUsers },
];

const LibraryInfrastructure = () => {
  return (
    <>
      <Navbar />
      <CTAButton />
 <PageHeader
          title="Infrastructure and Facilities"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Infrastructure and Facilities" },
          ]}
        />
      <div className="lib-container">
       
        <div className="lib-grid-wrapper">
          
          {/* Left Column: Book Stacking */}
          <div className="lib-card card-stacking">
        <div className="lib-img-wrapper vertical-img">
  <img 
    src="/DFC/LRC/Book-stacking-area/MCA00368.webp" 
    alt="Book Stacking Area" 
  />
</div>
            <div className="lib-content-box">
              <div className="lib-card-heading">Book Stacking Area</div>
              <ul className="lib-list">
                <li><strong>Capacity:</strong> 15,000 Books</li>
                <li>Subject wise labelled cupboards</li>
                <li>CDs/DVDs procured with books & periodicals</li>
                <li>6 National and International Journals</li>
                <li>190 IEEE ASPP International (e-journals)</li>
                <li>Student project reports for research needs</li>
              </ul>
            </div>
          </div>

          {/* Right Column: Two Horizontal Cards */}
          <div className="lib-right-column">
            
            {/* Top Right: Reading Section */}
            <div className="lib-card card-reading">
              <div className="lib-img-wrapper horizontal-img">
                <img 
                src="/DFC/LRC/General-reading-section/MCA00330.webp" 
                  alt="General Reading Section" 
                />
              </div>
              <div className="lib-content-box">
                <div className="lib-card-heading">General Reading Section</div>
                <div className="lib-columns-list">
                  <ul>
                    <li><strong>Seating Capacity:</strong> 100</li>
                    <li>Air conditioned room</li>
                    <li>Newspapers & Latest Updates Board</li>
                  </ul>
                  <ul>
                    <li>Journals & Magazines</li>
                    <li>Encyclopaedia & Handbooks</li>
                    <li>Dictionaries & Thesaurus</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Bottom Right: Digital Library */}
            <div className="lib-card card-digital">
              <div className="lib-img-wrapper horizontal-img">
                <img 
                  src="/DFC/LRC/Digital-Library/DL.webp" 
                  alt="Digital Library" 
                />
              </div>
              <div className="lib-content-box">
                <div className="lib-card-heading">Digital Library</div>
                <ul className="lib-list">
                  <li>9 DELL Opti-plex i3 (18.5" LCD)</li>
                  <li><strong>500 Mbps</strong> Dedicated Leased Line</li>
                  <li>4 Laptop Connection Points</li>
                  <li>Seating capacity: 13 (Fully AC)</li>
                  <li>Access e-Books, Syllabus & Question Papers</li>
                  <li>Search available books via <strong>Koha – OPAC</strong></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="lib-services-panel">
        <div className="lib-inner-container">
          <div className="lib-services-title">Library Services</div>
          <div className="lib-services-icons">
            {libraryServices.map(({ label, icon: ServiceIcon }) => (
              <div className="svc-item" key={label}>
                <ServiceIcon aria-hidden="true" focusable="false" />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LibraryInfrastructure;
